import {
  CustomerExceptionsPath,
  CustomerLoadBasePath,
  EXCEPTIONS_PATHS,
  IntegratedExceptionsPath,
  IntegratedTrackingBasePath,
  ShipmentBasePath,
  TmExceptionsPath,
} from '~/constants/urls'

import { CustomerType } from '~/__generated_types__/globalTypes'

export const isExceptionsPath = (pathname: string): boolean =>
  EXCEPTIONS_PATHS.includes(pathname as typeof EXCEPTIONS_PATHS[number])

type ListViewPaths = { exceptionsPath: string; listViewBasePath: string }

/* TODO: Standardize exceptions dashboard URL: https://baton-team.atlassian.net/browse/CVIZ-873 */
/** Maps a customer type to its list view route and exceptions route. */
export const getListViewPathsForCustomerType = (
  customerType: CustomerType | null | undefined
): ListViewPaths => {
  switch (customerType) {
    case CustomerType.Tm:
      return {
        exceptionsPath: TmExceptionsPath,
        listViewBasePath: ShipmentBasePath,
      }
    case CustomerType.Integrated:
      return {
        exceptionsPath: IntegratedExceptionsPath,
        listViewBasePath: IntegratedTrackingBasePath,
      }
    default:
      return {
        exceptionsPath: CustomerExceptionsPath,
        listViewBasePath: CustomerLoadBasePath,
      }
  }
}
